export default __webpack_public_path__ + "static/media/windows-cuate.4bf69421.png";